import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	deletedEntity: {
		id: 'eoc.escalation-policies.common.ui.responder-names.deleted-responder.no-translate',
		defaultMessage: 'Deleted responder',
		description: 'The text to display if the responder is deleted',
	},
});

export default messages;
